import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import MessageInterface from '../../api/MessageInterface';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import Utils from '../../utils';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
/** @typedef {import('../../api/Constants').InboxMessagesResponse} InboxMessagesResponse */

/** @typedef {import('../../api/Constants').InboxCategory} InboxCategory */

/** @typedef {import('../../api/Constants').InboxMessagePreview} InboxMessagePreview */

var INTERVAL = 60000;

var EventEmitter = require('events');

var InboxMessagesProvider = /*#__PURE__*/function (_EventEmitter) {
  _inherits(InboxMessagesProvider, _EventEmitter);

  var _super = _createSuper(InboxMessagesProvider);

  function InboxMessagesProvider() {
    var _this;

    _classCallCheck(this, InboxMessagesProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.EVENTKEY = 'INBOX_UPDATE';
    _this.state = {
      count: 0,
      categories: [],
      messages: [],
      timeStamp: null,
      init: false
    };

    _this.resetInbox = function () {
      _this.state = {
        count: 0,
        categories: [],
        messages: [],
        timeStamp: null,
        init: false
      };
    };

    _this.removeMessage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var removeFromServer,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                removeFromServer = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;

                _this.readMessage(id, false);

                _context.t0 = removeFromServer;

                if (!_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return MessageInterface.deleteInboxMessages(id);

              case 6:
                /** @type {InboxMessagePreview[]} */
                _this.state.messages = _this.state.messages.map(
                /** @param {InboxMessagePreview} msg */
                function (msg) {
                  var newMsg = msg;

                  if (newMsg.message_id === id) {
                    newMsg.deleted = true;
                  }

                  return newMsg;
                });
                _this.state.timeStamp = Date.now() - INTERVAL;

                _this.emit(_this.EVENTKEY);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.fetchNewMessages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _useFeatureFlags, hasFeature, msgResponse, messagesFromResponse;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature; // this.state.init = true;

              _this.state.timeStamp = Date.now();
              _context2.prev = 2;
              _context2.next = 5;
              return MessageInterface.getInboxMessages();

            case 5:
              msgResponse = _context2.sent;
              messagesFromResponse = transformObjectArrayResponse(msgResponse.messages).filter(function (msg) {
                return !Utils.isEmpty(msg) && msg.redeemed !== 'yes';
              });

              if (!hasFeature(FE_SNEAK_PEEK)) {
                messagesFromResponse = messagesFromResponse.filter(function (item) {
                  return !Utils.isEmpty(item) && item.action && item.action.search('sneakPeek:') === -1 || !Utils.isEmpty(item) && !item.action;
                });
              }

              _this.state.count = messagesFromResponse.filter(function (msg) {
                return !Utils.isEmpty(msg) && msg.message_read !== 'yes';
              }).length;
              /** @type {InboxCategory[]} */

              _this.state.categories = transformObjectArrayResponse(msgResponse.categories);
              /** @type {InboxMessagePreview[]} */

              _this.state.messages = messagesFromResponse.map(function (msg) {
                var newMsg = msg;
                newMsg.deleted = false;
                return newMsg;
              });
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              console.error(_context2.t0);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 13]]);
    }));
    return _this;
  }

  _createClass(InboxMessagesProvider, [{
    key: "getMessageCount",
    value:
    /**
     * @returns {Number}
     */
    function () {
      var _getMessageCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.checkIfExpired()) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.fetchNewMessages();

              case 3:
                return _context3.abrupt("return", this.state.count);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getMessageCount() {
        return _getMessageCount.apply(this, arguments);
      }

      return getMessageCount;
    }()
  }, {
    key: "getMessageCategories",
    value:
    /**
     * @returns {InboxCategory[]}
     */
    function () {
      var _getMessageCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.checkIfExpired()) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.fetchNewMessages();

              case 3:
                return _context4.abrupt("return", this.state.categories.concat([]));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getMessageCategories() {
        return _getMessageCategories.apply(this, arguments);
      }

      return getMessageCategories;
    }()
    /**
     * @returns {InboxMessagePreview[]}
     */

  }, {
    key: "getMessages",
    value: function () {
      var _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.checkIfExpired()) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return this.fetchNewMessages();

              case 3:
                return _context5.abrupt("return", this.state.messages.concat([]));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMessages() {
        return _getMessages.apply(this, arguments);
      }

      return getMessages;
    }()
    /**
     * Get a particular message by Id
     * @param {Number} id Id for the message
     */

  }, {
    key: "getMessage",
    value: function getMessage(id) {
      var msg;

      for (var i = 0; i < this.state.messages.length; i++) {
        if (parseInt(this.state.messages[i].message_id) === parseInt(id)) {
          msg = this.state.messages[i];
          break;
        }
      }

      return msg;
    }
    /**
     * Set a message to read status from the cache
     * @param {Number} id Id for the message
     * @param {Boolean} notify Whether or not it should emit an event
     */

  }, {
    key: "readMessage",
    value: function readMessage(id) {
      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /** @type {InboxMessagePreview} */
      var msg = this.getMessage(id);

      if (!Utils.isEmpty(msg) && msg.read_status !== 'yes') {
        msg.read_status = 'yes';

        if (this.state.count > 0) {
          this.state.count--;
        }

        if (notify) this.emit(this.EVENTKEY);
      }
    }
    /**
     * Remove a message from the cache
     * @param {Number} id Id for the message
     */

  }, {
    key: "checkIfExpired",
    value:
    /**
     * @private
     * @returns {Boolean}
     */
    function checkIfExpired() {
      return !this.state.init || Date.now() - this.state.timeStamp > INTERVAL // 1 minute
      ;
    }
    /**
     * @private
     */

  }]);

  return InboxMessagesProvider;
}(EventEmitter);

var inboxMessagesProvider = new InboxMessagesProvider();
export default inboxMessagesProvider;